module.exports = __webpack_public_path__ + "media/images/redesign-images/cm/cm-social-share-banner-ae88b19efbbb009c79660698f755b18e.jpg";